import React from 'react';

import { Box, Stack } from '@atlaskit/primitives/compiled';
import Form from '@atlaskit/form';
import { token } from '@atlaskit/tokens';
import { cssMap } from '@atlaskit/css';

import { RestartAudioButton } from '@atlassian/ai-audio';

import { fg } from '@confluence/feature-gating';

import type { CustomLengthType, CustomToneType } from '../../../../types/customizationTypes';

import { DurationSelector } from './DurationSelector';
import { ToneSelector } from './ToneSelector';

const styles = cssMap({
	formWrapper: {
		paddingInline: token('space.075'),
	},
});

interface CustomizationFormValues {
	length: CustomLengthType;
	tone: {
		value: CustomToneType;
	};
}

export const CustomizePanel = () => {
	return (
		<Box xcss={styles.formWrapper}>
			{fg('platform-design_system_team-form_conversion') ? (
				<Form<CustomizationFormValues> onSubmit={() => {}}>
					<Stack space="space.100">
						<ToneSelector />
						<DurationSelector />
						<RestartAudioButton />
					</Stack>
				</Form>
			) : (
				<Form<CustomizationFormValues> onSubmit={() => {}}>
					{({ formProps }) => (
						<form {...formProps}>
							<Stack space="space.100">
								<ToneSelector />
								<DurationSelector />
								<RestartAudioButton />
							</Stack>
						</form>
					)}
				</Form>
			)}
		</Box>
	);
};
